import { Navigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useOnboardingAccess } from '../hooks/useOnboardingAccess';

interface OnboardingAccessGuardProps {
  children: React.ReactNode;
}

function OnboardingAccessGuard({ children }: OnboardingAccessGuardProps) {
  const { isBlocked, isLoading } = useOnboardingAccess();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      </div>
    );
  }

  if (isBlocked) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default OnboardingAccessGuard;
